import type { RouteRecordRaw } from '@fusapp-work/shell'

export const routes: RouteRecordRaw[] = [
  {
    path: '/communication/transactions', name: 'communication-transactions',
    component: () => import('../features/communication/transactions/TransactionsView.vue'),
    meta: { shellSection: 'transactions' },
  },
  {
    path: '/communication/channels/:id([a-fA-F0-9]{24})', name: 'communication-channel-detail',
    component: () => import('../features/communication/channels/ChannelDetailView.vue'),
    meta: { shellSection: 'channels' },
  },
  {
    path: '/communication/templates/:id([a-fA-F0-9]{24})', name: 'communication-template-detail',
    component: () => import('../features/communication/templates/TemplateDetailView.vue'),
    meta: { shellSection: 'templates' },
  },
  {
    path: '/communication/templates', name: 'communication-templates',
    component: () => import('../features/communication/templates/TemplatesView.vue'),
    meta: { shellSection: 'templates' },
  },
  {
    path: '/communication/channels', name: 'communication-channels',
    component: () => import('../features/communication/channels/ChannelsView.vue'),
    meta: { shellSection: 'channels' },
  },
  {
    path: '/identity/welcome', name: 'identity-welcome',
    component: () => import('../features/identity/welcome/WelcomeListView.vue'),
    meta: { shellSection: 'welcome' },
  },
  {
    path: '/identity/welcome/personnel', name: 'identity-welcome-personnel',
    component: () => import('../features/identity/welcome/WelcomeEditorView.vue'),
    meta: { shellSection: 'welcome' },
  },
  {
    path: '/identity/entra',
    name: 'identity-entra',
    component: () => import('../features/identity/entra/EntraView.vue'),
    meta: { shellSection: 'entra' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/organization/companies',
    name: 'organization-companies',
    component: () => import('../features/organization/companies/CompaniesView.vue'),
    meta: { shellSection: 'companies' },
  },
  {
    path: '/organization/users',
    name: 'organization-users',
    component: () => import('../features/organization/personnel/PersonnelView.vue'),
    meta: { shellSection: 'users' },
  },
  {
    path: '/organization/roles',
    name: 'organization-roles',
    component: () => import('../features/organization/roles/RolesView.vue'),
    meta: { shellSection: 'roles' },
  },
  {
    path: '/organization/audit',
    name: 'organization-audit',
    component: () => import('../features/organization/audit/AuditView.vue'),
    meta: { shellSection: 'audit' },
  },
  // Console v2.dc.html:3043-3044 Entegrasyon / Altyapı: the shell sections exist; the features are not connected yet.
  {
    path: '/integration/secrets',
    name: 'integration-secrets',
    component: () => import('../components/shell/PlatformPendingView.vue'),
    meta: { shellSection: 'secrets' },
  },
  {
    path: '/integration/connections',
    name: 'integration-connections',
    component: () => import('../components/shell/PlatformPendingView.vue'),
    meta: { shellSection: 'connections' },
  },
  {
    path: '/integration/keys',
    name: 'integration-keys',
    component: () => import('../components/shell/PlatformPendingView.vue'),
    meta: { shellSection: 'keys' },
  },
  {
    path: '/infrastructure/regions',
    name: 'infrastructure-regions',
    component: () => import('../components/shell/PlatformPendingView.vue'),
    meta: { shellSection: 'regions' },
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
]
